import _defineProperty from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["style", "titleText", "link", "buttonText", "buttonIcon", "onButtonClick", "LinkComponent", "textStyle", "theme"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import Text from '../text/text.component.js';
import Button from '../buttons/button.component.js';
import '../../App.css.js';
var Div = styled.div.withConfig({
  displayName: "start-young-headercomponent__Div",
  componentId: "sc-m8s5ya-0"
})(["width:100%;max-width:940px;.btn-start-young-header{min-width:152px;max-width:170px;margin-top:34px;}@media screen and (max-width:768px){.btn-start-young-header{width:unset;margin-top:24px;}}"]);
var TextTitle = styled(Text).withConfig({
  displayName: "start-young-headercomponent__TextTitle",
  componentId: "sc-m8s5ya-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:34px;line-height:44px;}"]);
var StartYoungHeader = function StartYoungHeader(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    link = _ref.link,
    buttonText = _ref.buttonText,
    buttonIcon = _ref.buttonIcon,
    onButtonClick = _ref.onButtonClick,
    LinkComponent = _ref.LinkComponent,
    textStyle = _ref.textStyle,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, _extends({
    style: _objectSpread({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginLeft: "auto",
      marginRight: "auto",
      boxSizing: "border-box"
    }, style)
  }, rest), /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "display",
    fontSize: "small",
    style: _objectSpread({
      textAlign: "center"
    }, textStyle)
  }, titleText), /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-start-young-header",
    type: "primary",
    color: "green",
    active: "true",
    borderRadiusType: "rounded",
    text: buttonText,
    textType: "large",
    icon: buttonIcon,
    iconPosition: "right",
    onClick: onButtonClick,
    heightButton: "xlarge",
    link: link,
    LinkComponent: LinkComponent,
    style: {
      //opacity: 0,
      lineHeight: "1.1"
      /*animationName: "textHeaderFadeIn",
      animationDuration: "1s",
      animationDelay: "1.4s",
      animationFillMode: "forwards",*/
    }
  }));
};

export { StartYoungHeader as default };